import React, { useContext, useEffect, useState, useCallback } from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import Header from '../components/header/header'
import Sidebar from "../components/sidebar/sidebar";
import APIServicenew from "../utils/APIGeneralService.js";
import { UserContext } from "../context/UserContextProvider.js";
import Dashboard from '../pages/Dashboard/Dashboard.js';
import Profile from '../pages/profile/Profile.js';
import ProfileEdit from '../pages/profile/ProfileEdit.js';
import RoleList from '../pages/RolesPermission/RoleList.js';
import AddRole from '../pages/RolesPermission/AddRole.js';
import AddSubadmin from '../pages/SubAdmin/AddSubadmin.js';
import ManageAdmin from '../pages/SubAdmin/ManageAdmin.js';
import Topic from '../pages/Topic/Topic.js';
import Generate_topic from "../pages/Topic/Generate_topic.js";
import Topic_details from "../pages/Topic/Topic_details.js";
import Lesson from '../pages/Lesson/Lesson.js';
import Lesson_details from '../pages/Lesson/Lesson_details.js';
import AddFAQ from '../pages/faq/AddFAQ.js';
import ManageFAQ from '../pages/faq/ManageFAQ.js';

import AddGrade from '../pages/grade/AddGrade.js';
import ManageGrade from '../pages/grade/ManageGrade.js';

import AddSchool from '../pages/school/AddSchool.js';
import ManageSchool from '../pages/school/ManageSchool.js';
import SchoolDetails from '../pages/school/SchoolDetails.js';
import AddCourse from '../pages/course/AddCourse.js';
import ManageCourse from '../pages/course/ManageCourse.js';
import CourseDetails from '../pages/course/CourseDetails.js';


import ManageStudent from '../pages/student/ManageStudent.js';
import AddStudent from '../pages/student/AddStudent.js';
import StudentDetails from '../pages/student/StudentDetails.js';
import ActionLogs from '../pages/ActionLogs/ActionLogs.js';
import ActionLogDetails from '../pages/ActionLogs/ActionLogDetails.js';
import CourseStudentPerformance from "../pages/student/CourseStudentPerformance.js";
import CoursePerformance from "../pages/course/CoursePerformance.js";
import NotAuthorized from "../components/Not-authorized/notauthorized.js";

const Admin = (props) => {
  const [isOpen, setIsOpen] = useState(() => {
    const saved = localStorage.getItem("sidebarOpen");
    return saved !== null ? saved === "true" : true;
  });

  const handleSetIsOpen = useCallback((val) => {
    const next = typeof val === "function" ? val(isOpen) : val;
    setIsOpen(next);
    localStorage.setItem("sidebarOpen", String(next));
  }, [isOpen]);

  return (
    <>

      <div className='msl_dashboard_area'>
        <Header />
        <Container fluid className="px-0">
          <section className='msl_dashboard_inner '>
            <aside>
              <Sidebar isOpen={isOpen} setIsOpen={handleSetIsOpen} />
            </aside>
            <div className={`msl_inner_content py-3 ${isOpen ? "open" : "close"}`}>
              <Routes>
                <Route path="/profile" element={<Profile />} />
                <Route path="/profile/edit/:id" element={<ProfileEdit />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/add-role/:id?" element={<AddRole />} />
                <Route path="/role-list" element={<RoleList />} />
                <Route path="/sub-admin" element={<ManageAdmin />} />
                <Route path="/update-sub-admin/:id?" element={<AddSubadmin />} />
                <Route path="/add-sub-admin" element={<AddSubadmin />} />
                <Route path="/topic" element={<Topic />} />
                <Route path="/generate-topic" element={<Generate_topic/>} />
                <Route path="/topic-detail/:id" element={<Topic_details/>} />
                <Route path="/lesson" element={<Lesson />} />
                <Route path="/lesson-detail/:id" element={<Lesson_details />} />

                <Route path="/faq" element={<ManageFAQ />} />
                <Route path="/update-faq/:id?" element={<AddFAQ />} />
                <Route path="/add-faq" element={<AddFAQ />} />

                 <Route path="/grade" element={<ManageGrade />} />
                <Route path="/update-grade/:id?" element={<AddGrade />} />
                <Route path="/add-grade" element={<AddGrade />} />

                <Route path="/school" element={<ManageSchool />} />
                <Route path="/add-school" element={<AddSchool />} />
                <Route path="/update-school/:id?" element={<AddSchool />} />
                <Route path="/school-detail/:id" element={<SchoolDetails />} />

                <Route path="/course" element={<ManageCourse />} />
                <Route path="/add-course" element={<AddCourse />} />
                <Route path="/update-course/:id?" element={<AddCourse />} />
                <Route path="/course-detail/:id" element={<CourseDetails />} />

                <Route path="/student" element={<ManageStudent />} />
                <Route path="/student-detail/:id" element={<StudentDetails />} />
                <Route path="/add-student" element={<AddStudent />} />
                <Route path="/update-student/:id?" element={<AddStudent />} />
                <Route path="/action_logs" element={<ActionLogs />} />
                <Route path="/action_log_detail/:id" element={<ActionLogDetails />} />
                <Route 
                  path="/student-course-performance/:studentId/:courseId" 
                  element={<CourseStudentPerformance />} 
                />
                <Route
                  path="/course-performance/:courseId"
                  element={<CoursePerformance />}
                />
                <Route path="*" element={<NotAuthorized />} />
              </Routes>
            </div>
          </section>
        </Container>
      </div>
    </>
  );
};

export default Admin;
